<template>
  <div class="relative flex shrink-0">
    <img
      v-for="(photo, index) in SPECIALIST_PHOTOS"
      :key="photo"
      class="relative rounded-full border-solid"
      :class="ringClass"
      :style="{
        width: `${size}px`,
        height: `${size}px`,
        marginRight: index < SPECIALIST_PHOTOS.length - 1 ? `-${overlap}px` : 0,
        zIndex: SPECIALIST_PHOTOS.length - index,
      }"
      :src="photo"
      alt=""
      :width="size"
      :height="size"
      loading="lazy"
    >
    <span
      v-if="online"
      class="absolute right-[-1px] bottom-0 z-10 rounded-full border-solid bg-green"
      :class="ringClass"
      :style="{ width: `${onlineDotSize}px`, height: `${onlineDotSize}px` }"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';

import { SPECIALIST_PHOTOS } from './concierge';

const props = defineProps({
  size: {
    type: Number,
    required: true,
  },
  overlap: {
    type: Number,
    required: true,
  },
  // Border width and colour of the ring that separates the photos, matching the surface behind them
  ringClass: {
    type: String,
    required: true,
  },
  online: {
    type: Boolean,
    default: false,
  },
});

const onlineDotSize = computed(() => Math.round(props.size * 0.3));
</script>
